import { makeStyles } from "@material-ui/styles"

export const useXlsBorderStyle = makeStyles(() => ({
  xlsBorder: {
    borderColor: "#ADD8A6",
    backgroundColor: "#E8F4E6",
  },
}));
